import api from "../api";

export function homePage() {
    return api.get('/home/images')
}

export function businessPages(id: number) {
    return api.get(`/business/page/data/${id}`)
}

export function getBrands() {
    return api.get('/brands');
}

export function getBrand(search_name: string) {
    return api.get(`/brands/${search_name}`);
}

export function getVacancies() {
    return api.get('/vacancies');
}

export function getVacancy(slug: string) {
    return api.get(`/vacancies/${slug}`);
}

export function getNewsStories(page = 1, perPage = 10) {
    return api.get(`/news?page=${page}&per_page=${perPage}`);
}

export function getCustomNews(slug: string) {
    return api.get(`/news/custom/${slug}`);
}

export function getTemplate(slug: string) {
    return api.get(`/news/template/${slug}`);
}
export function getNewsStory(slug: string) {
    return api.get(`/news/${slug}`);
}

export function getWebinars() {
    return api.get('/webinars');
}

export function getGalleries() {
    return api.get('/galleries');
}

export function getGallery(slug: string) {
    return api.get(`/galleries/${slug}`);
}

export function getPodcasts() {
    return api.get('/podcasts');
}

export function getProductInfo(slug: string) {
    return api.get(`/product/${slug}`);
}

export function getRecommendations(brand: string, product: string) {
    return api.get(`/recommendations/${product}/${brand}`);
}

export function getOffices() {
    return api.get('/offices');
}

export function subscribeToNewsletter(formData: FormData) {
    return api.post('/subscribe', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

export function getCultivars() {
    return api.get('/cultivars');
}

export function getStyles() {
    return api.get('/styles');
}

export function getWinesByCultivar(cultivarIds: number[]) {
    const requestData = {
        cultivar: cultivarIds
    };

    return api.post('/product/cultivars', requestData)
        .then(response => {
            return response;
        })
        .catch(error => {
            console.error('getWinesByCultivar - Error:', error);
            throw error;
        });
}

export function getWinesByStyle(styleIds: number[]) {
    const requestData = {
        styles: styleIds
    };
    return api.post('/product/styles', requestData)
        .then(response => {
            return response;
        })
        .catch(error => {
            console.error('getWinesByStyle - Error:', error);
            throw error;
        });
}

export function getWebinar(slug: string) {
    return api.get(`/webinars/${slug}`);
}

export function getPodcast(slug: string) {
    return api.get(`/podcasts/${slug}`);
}

export function searchProducts(search_name: string) {
    return api.get(`/products/search/${search_name}`)
}

export function customerLogin(customerLogin: string)
{
    const formData = new FormData();
    formData.append('customer_code', customerLogin);

    return api.post('/customer-login', formData)
}
export function getWinesByBrand(filters: {
    brand?: string;
    style?: string;
    cultivator?: string;
    range?: string;
    customer_id?: string;
}) {
    const requestData: any = {};

    if (filters.brand) requestData.brand = filters.brand;
    if (filters.style) requestData.style = filters.style;
    if (filters.cultivator) requestData.cultivator = filters.cultivator;
    if (filters.range) requestData.range = filters.range;
    if (filters.customer_id) requestData.customer_id = filters.customer_id;

    return api.post('/wines/by-brand', requestData)
        .then(response => {
            return response;
        })
        .catch(error => {
            console.error('getWinesByBrand - Error:', error);
            throw error;
        });
}

export function getInternationalTeam() {
    return api.get('/international/team');
}

export function getInternationalPortfolio() {
    return api.get('/international/brands');
}

export function getInternationalBrand(slug: string) {
    return api.get(`/international/brands/${slug}`);
}

export function getInternationalProduct(slug: string) {
    return api.get(`/international/products/${slug}`);
}
